const TUIChat = {
  '按Enter发送，Ctrl+Enter换行': 'Enter - отправить, Ctrl+Enter - новая строка',
  '表情': '[Эмоция]',
  '查看更多': 'Показать ещё',
  '撤回': 'Отозвать',
  '撤回了一条消息': ' отозвал(а) сообщение',
  '打开': 'Открыть',
  '单击下载': 'Нажмите для скачивания',
  '下载': 'Скачать',
  '点此投诉': 'Пожаловаться',
  '点击处理': 'Обработать',
  '对方正在输入': 'Печатает...',
  '发起群视频': 'Начать групповой видеозвонок',
  '发起群语音': 'Начать групповой аудиозвонок',
  '发起通话': 'Начать звонок',
  '发送失败': 'Ошибка отправки',
  '复制': 'Копировать',
  '复制成功': 'Скопировано',
  '该消息不存在': 'Сообщение не существует',
  '关闭阅读状态': 'Отключить статус прочтения',
  '管理员开启全员禁言': 'Админ включил режим "Только чтение"',
  '欢迎使用TUICallKit': 'Добро пожаловать в TUICallKit',
  '回到最新位置': '',
  '回复': 'Ответить',
  '回复详情': 'Детали ответа',
  '集成TUICallKit': 'Интеграция TUICallKit',
  '检测到您暂未集成TUICallKit，无法体验音视频通话功能': 'Обнаружено, что TUICallKit не интегрирован - аудио/видеозвонки недоступны',
  '结束群聊': 'Завершить групповой звонок',
  '进行体验': 'для тестирования',
  '经度': 'Долгота',
  '拒绝': 'Отклонить',
  '拒绝通话': 'Отклонить звонок',
  '开通腾讯实时音视频服务': 'Активировать Tencent RTC',
  '聊天记录': '[История чата]',
  '描述': 'Описание',
  '内容包含敏感词汇': 'Обнаружены запрещённые слова',
  '您': 'Вы',
  '您当前购买使用的套餐包暂未开通此功能': 'Ваш текущий тарифный план не поддерживает эту функцию',
  '您当前购买使用的套餐包暂未开通群消息已读回执功能': 'Ваш тариф не включает подтверждение прочтения групповых сообщений',
  '您当前购买使用的套餐包暂未开通在线用户列表功能': 'Ваш тариф не поддерживает список онлайн-пользователей',
  '您已被管理员禁言': 'Администратор отключил вам возможность писать',
  '您有': 'У вас есть',
  '请点击': 'Нажмите',
  '请输入消息': 'Введите сообщение',
  '取消': 'Отмена',
  '取消通话': 'Отменить звонок',
  '全部已读': 'Все прочитано',
  '确定': 'Подтвердить',
  '确认重发该消息？': 'Подтвердить повторную отправку?',
  '人关闭阅读状态': ' чел. отключили статус прочтения',
  '人未读': ' не прочитали',
  '人已读': ' прочитали',
  '删除': 'Удалить',
  '涉及敏感内容': 'Обнаружен чувствительный контент',
  '申请加入': 'Запрос на вступление',
  '视频': '[Видео]',
  '视频通话': 'Видеозвонок',
  '条回复': ' ответов',
  '条入群申请': ' заявок в группу',
  '条新消息': ' новых сообщений',
  '通话时长': 'Длительность звонка',
  '同意': 'Согласиться',
  '图片': '[Изображение]',
  '图片消息失败,无效的图片格式': 'Ошибка: неверный формат изображения',
  '纬度': 'Широта',
  '未读': 'Не прочитано',
  '位置': '[Местоположение]',
  '文件': '[Файл]',
  '文件不存在,请检查文件路径是否正确': 'Файл не найден, проверьте путь',
  '文件大小超出了限制,如果上传文件,最大限制是100MB': 'Превышен лимит (макс. 100MB)',
  '文件消息失败,禁止发送违规封禁的文件': 'Ошибка: запрещённый файл',
  '我': 'Я',
  '无法查看': 'Невозможно просмотреть',
  '无法定位到原消息': 'Не удалось найти исходное сообщение',
  '无法收听': 'Невозможно прослушать',
  '正在加载': 'Загрузка...',
  '加载结束': 'Завершено',
  '无应答': 'Нет ответа',
  '系统消息': 'Системное сообщение',
  '消息': '[Сообщение]',
  '消息或者资料中文本存在敏感内容,发送失败': 'Обнаружен запрещённый контент в сообщении - отправка отклонена',
  '消息详情': 'Детали сообщения',
  '消息长度超出限制,消息长度不要超过12K': 'Превышен лимит длины (макс. 12K)',
  '消息中图片存在敏感内容,发送失败': 'Обнаружена запрещённая картинка - отправка отклонена',
  '选择提醒的人': 'Выбрать контакт',
  '已读': 'Прочитано',
  '已过撤回时限': 'Срок отзыва истёк',
  '已接听': 'Принят',
  '已拒绝': 'Отклонён',
  '已同意': 'Одобрено',
  '引用': 'Цитата',
  '引用失败': 'Ошибка цитирования',
  '语音': '[Голосовое]',
  '语音通话': 'Аудиозвонок',
  '重新编辑': 'Редактировать',
  '重新发送': 'Отправить повторно',
  '转发': 'Переслать',
  '翻译': 'Перевести',
  '转文字': 'В текст',
  '隐藏': 'Скрыть',
  '转发给': 'Переслать в',
  '自定义': '[Своё сообщение]',
  '自定义消息': 'Своё сообщение',
  '腾讯云 IM': 'Tencent Cloud IM',
  '空': 'Пусто',
  '文本包含本地审核拦截词': 'Текст содержит запрещённые слова',
  '按住说话': 'Удерживайте для записи',
  '松开发送': 'Отпустите для отправки',
  '松手取消': 'Отпустите для отмены',
  '请检查麦克风访问权限': 'Пожалуйста, проверьте разрешения доступа к микрофону',
  '按压时间过短，请按压超过1秒': 'Время нажатия слишком короткое, удерживайте более 1 секунды',
  '录音结束提醒': 'Запись остановится через',
  '语音播放失败': 'Ошибка воспроизведения голоса',
  '正在录音': 'Идёт запись',
  '继续上滑可取消': 'Потяните вверх для отмены',
  '松开手指 取消发送': 'Отпустите для отмены',
  '此机型暂不支持复制功能': 'Эта модель не поддерживает копирование',
  '请开通翻译功能': 'Включите перевод',
  '请开通语音转文字功能': 'Включите преобразование голоса',
  '翻译中': 'Перевод...',
  '转换中': 'Конвертация...',
  '由IM提供翻译支持': 'Перевод через IM',
  '所有人': 'Все',
  '已达到表情回应上限数量': 'Достигнут лимит реакций',
  '等': 'и др.',
  '人': 'чел.',
  '返回': 'Назад',
  '关闭': 'Закрыть',
  '多选': 'Выбрать',
  '合并转发': 'Объединённая пересылка',
  '逐条转发': 'Поочерёдная пересылка',
  '未选择消息': 'Сообщения не выбраны',
  '[草稿]': '[Черновик]',
  '[消息]': '[Сообщение]',
  '[文本]': '[Текст]',
  '[自定义消息]': '[Своё сообщение]',
  '[图片]': '[Изображение]',
  '[音频]': '[Аудио]',
  '[语音]': '[Голосовое]',
  '[视频]': '[Видео]',
  '[文件]': '[Файл]',
  '[位置]': '[Местоположение]',
  '[地理位置]': '[Геопозиция]',
  '[动画表情]': '[Анимированный стикер]',
  '[群提示]': '[Групповое уведомление]',
  '[群提示消息]': '[Групповое оповещение]',
  '[聊天记录]': '[История чата]',
  '[机器人自定义消息]': '[Кастомное сообщение бота]',
  '引用内容已撤回': 'Цитируемое сообщение отозвано',
  '群聊的聊天记录': 'История группового чата',
  '和': 'и',
  '的聊天记录': 'история переписки',
  '请升级IMSDK到v2.10.1或更高版本查看此消息': 'Обновите IMSDK до v2.10.1+ для просмотра',
  '该群聊已被解散': 'Группа удалена',
  '您已被管理员移出群聊': 'Администратор исключил вас из группы',
  '您已退出该群聊': 'Вы вышли из группы',
  '您已被禁止聊天': 'Вам запрещено писать',
  '账号被强制下线': 'Аккаунт был принудительно выведен',
  '登录失败': 'Вход в систему не удалось',
  '链接':'[Ссылка]',
};

export default TUIChat;
